module.exports = __webpack_public_path__ + "static/media/akar-icons--augmented-reality.65b99a2a.png";